"use client";

import { EventEnum } from "@sprawdzonabron/shared";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

import { useAnalyticsEvent } from "../../api/hooks/useAnalyticsEvent";

export const ThemeSwitcher = () => {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme } = useTheme();

  const postThemeSwitcherEvent = useAnalyticsEvent(EventEnum.ThemeSwitcher);

  useEffect(() => setMounted(true), []);

  if (!mounted) {
    // Avoid rendering mismatch
    return (
      <div className="w-10 h-10 p-2 rounded-full bg-slate-200 dark:bg-slate-800 animate-pulse" />
    );
  }

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    postThemeSwitcherEvent(newTheme);
    setTheme(newTheme);
  };

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors"
      aria-label="Toggle theme"
    >
      {theme === "dark" ? "☀️" : "🌙"}
    </button>
  );
};
